import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch((err) => err)
}

const routes = [
  {
    path: '/',
    redirect: '/loginform'
  },
  {
    path: '/login',
    redirect: '/loginform'
  },
  {
    path: '/loginform',
    component: () => import('@/views/login/LoginForm')
  },
  {
    path: '/success',
    component: () => import('@/views/login/success')
  },
  {
    path: '/successDetail',
    component: () => import('@/views/login/successDetail')
  },
  {
    path: '/apply',
    component: () => import('@/views/login/apply')
  },
  {
    path: '/contact',
    component: () => import('@/views/login/contact')
  },
  {
    path: '/layout',
    component: () => import('@/layout/Layout'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/home/Temp'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/regRecord',
        component: () => import('@/views/individualUser/registrationRecord/registrationRecord'),
        meta: {
          menuId: 1011,
          title: '报名记录',
        }
      },

      {
        path: '/certifiSelection',
        component: () => import('@/views/authentication/certifiSelection'),
        meta: {
          title: '认证中心'
        }
      },
      {
        path: '/certifiForm',
        component: () => import('@/views/authentication/certifiForm'),
        meta: {}
      },
      {
        path: '/personalForm',
        component: () => import('@/views/authentication/personalForm'),
        meta: {}
      },
      {
        path: '/position',
        component: () => import('@/views/position_center/PositionManage'),
        meta: {
          menuId: 1012,
          title: '职位管理'
        }
      },

      {
        path: '/blacklist',
        component: () => import('@/views/blacklist/index'),
        meta: {
          menuId: 1005,
          title: '黑名单'
        }
      },
      {
        path: '/trm',
        component: () => import('@/views/trm/index'),
        meta: {
          menuId: 1005,
          title: '储备人才管理'
        }
      },
      {
        path: '/pubTalent',
        component: () => import('@/views/pubTalent/index'),
        meta: {
          menuId: 1005,
          title: '公共人才库'
        }
      },
      {
        path: '/project',
        component: () => import('@/views/project/index'),
        meta: {
          menuId: 1003,
          title: '招聘计划管理'
        }
      },
      {
        path: '/factoryList',

        component: () => import('@/views/customer_center/index'),
        meta: {
          title: '客户/机构',
          menuId: 1013
        }
      },
      {
        path: '/registration',

        component: () => import('@/views/registration/index'),
        meta: {
          title: '报名管理',
          menuId: 1004
        }
      },
      {
        path: '/recruitment',

        component: () => import('@/views/recruitment/index'),
        meta: {
          title: '招聘报名',
          menuId: 1006
        }
      },
      {
        path: '/personnel',

        component: () => import('@/views/personnel/index'),
        meta: {
          title: '人事管理',
          menuId: 1007
        }
      },
      {
        path: '/BuyCenter',
        component: () => import('@/views/buy/BuyCenter')
      },
      {
        path: '/user',
        meta: {
          menuId: 1016,
          title: '管理人员设置'
        },
        component: () => import('@/views/user_center/MyColleague')
      },
      {
        path: '/role',
        meta: {
          menuId: 1017,
          title: '角色及权限管理'
        },
        component: () => import('@/views/role_center/Authority')
      },
      {
        path: '/personnelList',
        component: () => import('@/views/talent_center/TalentPool'),
        meta: {
          menuId: 75,
          title: '员工管理'
        }
      },
      {
        path: '/jobHunting',
        component: () => import('@/views/individualUser/jobHunting/index'),
        meta: {
          menuId: 1010,
          title: '找工作',
        }
      },
      {
        path: '/afCompany',
        component: () => import('@/views/individualUser/afCompany/index'),
        meta: {
          menuId: 1009,
          title: '心仪于我',
        }
      },
      {
        path: '/demo',
        component: () => import('@/views/demo/demoTabs'),
        redirect: '/demo/demoIndex',
        children: [
          {
            path: '/demo/demoIndex',
            meta: {
              menuId: 39,
              title: 'demo页'
            },
            component: () => import('@/views/demo/demoIndex')
          }

        ]
      },

    ]
  }, {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import('@/views/404.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(function (to, from, next) {
  const urlParams = new URLSearchParams(window.location.search);
  const auth = urlParams.get('Authorization') || '';
  if (auth) {
    localStorage.setItem('Authorization', decodeURIComponent(auth));
  }
  // 判断是否存在token
  if (!localStorage.getItem('Authorization')) {
    // 判断去往的页面是不是登录页
    if (to.path == '/loginform' || to.path == '/success' || to.path == '/successDetail' || to.path == '/apply' || to.path == '/contact' || to.path == '/mobileRecorder' || to.path == '/rec') {
      next()
    } else if (to.path != '/login') {
      next('/login')
    }
  }
  next()
})
router.afterEach((to, from) => {
  if (to.path.indexOf('console') !== -1) {
    window.localStorage.removeItem('Authorization')
  } else {
    window.localStorage.removeItem('admin_Authorization')
  }
})

export default router
